import { BLACKLIST_ORIGIN_LABELS } from "src/constants/blacklists";
import { useT } from "src/internationalization";
import { BlacklistElementOrigin } from "src/types/blacklist";

export const useGetBlacklistElementOriginLabel = () => {
  const t = useT();

  const getBlacklistElementOriginLabel = (origin: BlacklistElementOrigin) => {
    return t(BLACKLIST_ORIGIN_LABELS[origin]);
  };

  return getBlacklistElementOriginLabel;
};
